import React from 'react';
import DebugBoxSmall from './DebugBoxSmall';

/** Place within a larger debug box or a production component. **/
const DebugState = ({ title, state, withinDebugBox = false }) =>
    <DebugBoxSmall withinDebugBox={ withinDebugBox }>
        <p style={ { marginBlockStart: '0px' } }>{title}:</p>
        <pre style={ { height: '140pt', overflow: 'auto', border: 'dotted 1px black' } }>
            {JSON.stringify(state, null,2)}
        </pre>
    </DebugBoxSmall>;

export default DebugState;
